import styled from "styled-components";
export const SubmitReqPreFormStyled = styled.div`
  p {
    font-size: 0.85em;
    color: #353a50;
  }

  .cls-2 {
    fill: none;
    stroke: #2a2e43 !important;
    stroke-linecap: round;
  }
  .svg {
    position: absolute;
    right: 9px;
    top: 0;
    bottom: 0;
    height: 100%;
    /* display: flex;
    align-items: center;
    justify-content: center; */
  }
  background-color: white;
  width: 100%;
  padding: 7px;

  margin-top: 12px;
  border-radius: 15px;
  color: black;

  .submit-req-pre__calender {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    position: fixed;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9;
    background: rgba(0, 0, 0, 0.4);
  }
`;
export const ReciverContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 10px auto;
`;
export const ReciverInput = styled.input`
  border-radius: 8px;
  background-color: #eaebed;
  height: 4vh;
  width: 48%;
  padding: 10px;
`;
export const AddOtherDestinationBtn = styled.div`
  padding: 5px 12px;
  border-radius: 8px;
  background-color: #48cfad;
  width: 49%;
  color: #fff;
  text-align: center;
  cursor: pointer;
  font-weight: 999;
`;
export const AddOtherDestinationContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-between;
`;
export const MoreInfoStylrd = styled.div`
  border-radius: 8px;
  background-color: #eaebed;
  margin: 10px 0;
  padding: 5px;
  text-align: center;
  font-weight: 999;
  cursor: pointer;
`;
